import React from 'react'

import TypeConversionApplicationDetails from './TypeConversionApplicationDetails'

export default function TypeConversion() {
    return (
        // <div>TypeConversion </div>
       <TypeConversionApplicationDetails/>
    )
}
